<template>
  <div id="footer">
    <section class="logo">
      <img src="../../assets/logo.jpg" alt="" />
      <span class="logo-name">照片家</span>
    </section>

    <section class="foot-navs">
      <ul>
        <li v-for="(item, index) in footerNavs" :key="index">
          <span v-if="index !== 0" class="line">|</span>
          <span @click="showHeader">
            <router-link :to="item.path" active-class="active">{{ item.label }}</router-link>
          </span>
        </li>
      </ul>
    </section>

    <!-- <section class="address">深圳市南山区南头街道振业国际商务中心2808D</section> -->
    <section class="address">
      <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2022020770号</a>
    </section>
    <section class="record">©版权所有2022 深圳照片家科技有限公司</section>
  </div>
</template>

<script>
import { PRODUCT_NAME } from "@/common/constant.js";

export default {
  name: "Footer",
  data() {
    return {
      footerNavs: [
        {
          label: "网站首页",
          path: "/home",
        },
        {
          label: PRODUCT_NAME.PHOTO_HOME,
          path: "/xc",
        },
        {
          label: PRODUCT_NAME.FRAME,
          path: "/xk",
        },
        // {
        //   label: PRODUCT_NAME.HARD_FRAME,
        //   path: '/ypxk'
        // },
        {
          label: "下载App",
          path: this.$global.isHuaqi ? "/huaqidownload" : "/download",
        },
        {
          label: "关于我们",
          path: "/about",
        },
      ],
    };
  },
  methods: {
    showHeader() {
      this.$bus.$emit("showHeader");
    },
  },
};
</script>

<style lang="scss" scoped>
#footer {
  background-color: #fff;
  position: relative;
  z-index: 1;
  padding: 6rem 0;
  .logo {
    width: 100%;
    height: 4.5rem;
    display: flex;
    justify-content: center;
    img {
      height: 100%;
      margin-right: 2rem;
    }
    .logo-name {
      font-size: 3rem;
      color: var(--theme-color);
      line-height: 4.5rem;
      letter-spacing: 0.3rem;
    }
  }

  .foot-navs {
    text-align: center;
    margin: 2rem 0;
    ul {
      display: inline-flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      .line {
        margin: 0 2rem;
        color: #888;
        font-size: 1.8rem;
      }
      a {
        color: #888;
        text-decoration: none;
        font-size: 1.8rem;
        letter-spacing: 0.1rem;
        &.active {
          color: var(--theme-color);
        }
      }
    }
  }
  .address {
    font-size: 1.5rem;
    letter-spacing: 0.05rem;
    color: #999;
    a {
      cursor: pointer;
      color: #999;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .record {
    @extend .address;
    margin-top: 1rem;
  }
}
@media (max-width: 768px) {
  #footer {
    .logo {
      height: 6vw;
      .logo-name {
        font-size: 5rem;
        line-height: 6vw;
      }
    }
    .foot-navs {
      ul {
        .line {
          margin: 0 2rem;
          font-size: 4rem;
        }
        a {
          font-size: 4rem;
        }
      }
    }
    .address {
      font-size: 3.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue